import SectionHeading from "./SectionHeading";
import { workCategories } from "@/mocks/catalog";

export default function Categories() {
  return (
    <section id="categories" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-content px-4 md:px-8">
        <SectionHeading
          eyebrow="作品类型"
          title="作品按内容形态分成六类，各有不同的观看场景"
          desc="同样是「作品」，内容形态差别其实很大。先按类型归类，能帮助你在浏览前就把范围缩小到合适的区间。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {workCategories.map((category) => (
            <article
              key={category.id}
              className="group overflow-hidden rounded-lg border border-background-200/70 bg-background-50"
            >
              <div className="relative h-44 w-full overflow-hidden md:h-48">
                <img
                  src={category.image}
                  alt={`${category.name}类型示意封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent"></div>
                <span className="absolute bottom-3 left-3 inline-flex items-center gap-1.5 rounded-full bg-primary-500/95 px-3 py-1 text-xs font-medium text-background-50">
                  <i className="ri-price-tag-3-line"></i>
                  {category.tagline}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">{category.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{category.desc}</p>
                <p className="mt-4 flex items-center gap-2 border-t border-background-200/70 pt-3 text-xs text-secondary-700">
                  <i className="ri-refresh-line text-base text-accent-600"></i>
                  {category.count}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}